import _get from 'lodash/get';

export const getActionButtonColor = commonSetting => {
  return _get(commonSetting, 'page[0].theme.color.actionButton', '#000000');
};

export const getPrimaryColor = commonSetting => {
  return _get(commonSetting, 'page[0].theme.color.primary', '#028CF0');
};

export const getSecondaryColor = commonSetting => {
  return _get(commonSetting, 'page[0].theme.color.secondary', '#D4F0F9');
};

export const getSecondary2Color = commonSetting => {
  return _get(commonSetting, 'page[0].theme.color.secondary2', '#D0D5EC');
};
